import React from 'react';
import logoCoopeuch from '../../../assets/img/logo-coopeuch.svg';
import imagenWebpay from '../../../assets/img/webpay.png';
import Skeleton from 'react-loading-skeleton';
import ContenedorError from './style';

const Header = ({mostrarBanner, comercioimg}) => {
    return (
        <ContenedorError>
            <div className="cabecera-webpay-coopeuch">
                <div className="logo">
                    <img src={logoCoopeuch} alt="coopeuch-logo" />
                </div>
                {!mostrarBanner?(
                    <div className="contenedor-imagenes-wepbay">
                        {comercioimg == ""? 
                        <Skeleton width={100} height={50} />
                        :<img src={comercioimg } alt="logo-comercio" />
                         }
                      
                       <img src={imagenWebpay} alt="logo-webpay" />
                    </div>
                ) : (
                  ""
                )}
            </div>
        </ContenedorError>
    )
}
export default Header;